/* ============================================================
   Appstle Custom Widget — appstle-custom-widget.js
   Upload to: Assets/
   ============================================================ */

(function () {
  'use strict';

  function initWidget(container) {
    var sectionId    = container.dataset.acw;
    var typeCards    = container.querySelectorAll('[data-acw-type]');
    var subPanel     = container.querySelector('[data-acw-panel="subscription"]');
    var onetimePanel = container.querySelector('[data-acw-panel="one-time"]');
    var subPriceEl   = container.querySelector('[data-acw-sub-price]');
    var otPriceEl    = container.querySelector('[data-acw-onetime-price]');
    var subCompareEl = container.querySelector('[data-acw-sub-compare]');
    var otCompareEl  = container.querySelector('[data-acw-onetime-compare]');
    var compareMode  = container.dataset.acwSubCompareMode || 'uvp';
    var savingsEl    = container.querySelector('.acw__savings-badge');
    var uspRow       = container.querySelector('[data-acw-usp]');
    var activeMode   = 'subscription';
    var savingsTemplate = container.dataset.acwSavingsTemplate || '';

    /* Produkt-Daten aus dem JSON-Block lesen */
    var data         = parseData(sectionId);
    var variantMap   = buildVariantMap(data);
    var moneyFormat  = data ? data.moneyFormat : null;

    var productForm  = findProductForm();
    var planInput    = getOrCreatePlanInput(productForm, container.dataset.acwInitialPlan || '');
    /* getOrCreateInputOrSelect: findet auch select[name="id"] damit kein Duplikat entsteht */
    var variantInput = getOrCreateInputOrSelect(productForm, 'id', container.dataset.acwCurrentVariant || '');
    var initialActivePlan = subPanel && subPanel.querySelector('.acw__plan-card--active');
    if (initialActivePlan) updateSavingsBadge(initialActivePlan.dataset.planDiscount);

    /* Gewünschter Zustand — wird laufend auf das (versteckte) Appstle-Widget gespiegelt.
       Appstle klinkt sich in window.fetch ein und überschreibt jeden /cart/add-Request
       mit seinem EIGENEN Widget-Zustand. Steht der auf "One-Time", landet das Produkt
       ohne Abo im Warenkorb — egal was in unserem Hidden-Input steht. */
    var desiredPlanId = initialActivePlan ? (initialActivePlan.dataset.acwPlan || null) : null;

    /* Appstle liest selling_plan aus seinem eigenen Widget-Radio, nicht aus unserem Hidden-Input.
       Beim Submit erzwingen wir daher den korrekten Wert — egal was Appstle vorher gesetzt hat. */
    if (productForm) {
      productForm.addEventListener('submit', function () {
        if (activeMode === 'subscription') {
          var activePlan = subPanel && subPanel.querySelector('.acw__plan-card--active');
          desiredPlanId = activePlan ? (activePlan.dataset.acwPlan || null) : null;
        } else {
          desiredPlanId = null;
        }
        if (planInput) planInput.value = desiredPlanId || '';
        /* Hidden-Input ans Formularende schieben: bei doppeltem selling_plan
           (Appstle-Radio + unser Input) gewinnt bei Shopify der LETZTE Wert. */
        if (productForm.lastElementChild !== planInput) productForm.appendChild(planInput);
        syncAppstle(desiredPlanId);
      }, true); /* capture: true → läuft vor allen anderen Submit-Handlern */
    }

    /* Initial-Sync: sobald das Appstle-Widget im DOM ist (es lädt asynchron und
       war der Grund für das "mal klappt's, mal nicht"), den aktiven Plan übertragen.
       Danach dauerhaft überwachen — Appstle rendert sein Widget neu (z. B. bei
       Varianten-Wechsel) und fällt dabei auf "One-Time" zurück. */
    whenAppstleReady(function () {
      syncAppstle(desiredPlanId);
      observeAppstle(function () { syncAppstle(desiredPlanId); });
    });

    /* ── Varianten-Wechsel (Thema-Event) ─────────────────── */
    listenVariantChange(productForm, function (variantId) {
      /* Variant-ID im Container-Attribut aktuell halten */
      container.dataset.acwCurrentVariant = variantId;

      var variant = variantMap[variantId];
      if (!variant) return;

      /* Einmalig 1x-Preis aktualisieren */
      var el1x = container.querySelector('[data-acw-price-1x]');
      if (el1x)    el1x.textContent    = formatMoney(variant.price, moneyFormat);
      if (otPriceEl) otPriceEl.textContent = formatMoney(variant.price, moneyFormat);

      /* Durchstreichpreise der Einmalkauf-Seite aktualisieren.
         3x/5x sind eigene Produkte und ändern sich beim Varianten-Wechsel nicht. */
      var otCompare = oneTimeCompare(variant);
      setCompare(otCompareEl, otCompare, moneyFormat);
      setCompare(container.querySelector('[data-acw-compare-1x]'), otCompare, moneyFormat);

      /* Abo-Plan-Preise aktualisieren */
      var planCards = subPanel ? subPanel.querySelectorAll('[data-acw-plan]') : [];
      planCards.forEach(function (card) {
        var planId = parseInt(card.dataset.acwPlan, 10);
        var alloc  = findAlloc(variant.sellingPlanAllocations, planId);
        var price  = alloc ? alloc.price : variant.price;
        var configuredDiscount = card.dataset.planDiscountConfigured;
        var planCompare = subCompare(variant, alloc, price);
        card.dataset.planPriceFmt   = formatMoney(price, moneyFormat);
        card.dataset.planCompare    = String(planCompare);
        card.dataset.planCompareFmt = planCompare ? formatMoney(planCompare, moneyFormat) : '';
        card.dataset.planDiscount = configuredDiscount || '0';
        if (card.classList.contains('acw__plan-card--active') && subPriceEl) {
          subPriceEl.textContent = formatMoney(price, moneyFormat);
        }
        if (card.classList.contains('acw__plan-card--active')) {
          setCompare(subCompareEl, planCompare, moneyFormat);
          updateSavingsBadge(card.dataset.planDiscount);
        }
      });
    });

    /* ── Kaufoption-Toggle ───────────────────────────────── */
    typeCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var type = card.dataset.acwType;
        if (type === activeMode) return;
        activeMode = type;

        typeCards.forEach(function (c) {
          var on = c.dataset.acwType === type;
          c.classList.toggle('acw__type-card--active', on);
          c.setAttribute('aria-pressed', String(on));
        });

        if (subPanel)     subPanel.classList.toggle('acw__plans--hidden',    type !== 'subscription');
        if (onetimePanel) onetimePanel.classList.toggle('acw__plans--hidden', type !== 'one-time');

        if (type === 'subscription') {
          var activePlan = subPanel && subPanel.querySelector('.acw__plan-card--active');
          var activePlanId = activePlan ? (activePlan.dataset.acwPlan || '') : '';
          desiredPlanId = activePlanId || null;
          if (planInput) planInput.value = activePlanId;
          setVariant(container.dataset.acwCurrentVariant);
          syncAppstle(desiredPlanId);
          if (uspRow) uspRow.classList.remove('acw__usp-row--hidden');

          document.dispatchEvent(new CustomEvent(
            'AppstleSubscription:SubscriptionWidget:SwitchedToSubscription', { detail: {} }
          ));
        } else {
          desiredPlanId = null;
          if (planInput) planInput.value = '';
          var activeOt = onetimePanel && onetimePanel.querySelector('.acw__plan-card--active');
          applyOnetimeCard(activeOt);
          syncAppstle(null);
          if (uspRow) uspRow.classList.add('acw__usp-row--hidden');

          document.dispatchEvent(new CustomEvent(
            'AppstleSubscription:SubscriptionWidget:SwitchedToOneTime', { detail: {} }
          ));
        }
      });
    });

    /* ── Abo-Plan-Auswahl ────────────────────────────────── */
    if (subPanel) {
      var planCards = subPanel.querySelectorAll('[data-acw-plan]');
      planCards.forEach(function (card) {
        card.addEventListener('click', function () {
          planCards.forEach(function (c) { c.classList.remove('acw__plan-card--active'); });
          card.classList.add('acw__plan-card--active');

          desiredPlanId = card.dataset.acwPlan || null;
          if (planInput) planInput.value = desiredPlanId || '';
          setVariant(container.dataset.acwCurrentVariant);
          syncAppstle(desiredPlanId);

          if (subPriceEl && card.dataset.planPriceFmt) {
            subPriceEl.textContent = decodeEntities(card.dataset.planPriceFmt);
          }
          setCompareText(subCompareEl, card.dataset.planCompareFmt);
          updateSavingsBadge(card.dataset.planDiscount);

          document.dispatchEvent(new CustomEvent(
            'AppstleSubscription:SubscriptionWidget:SellingPlanSelected'
          ));
          document.dispatchEvent(new CustomEvent(
            'AppstleSubscription:SubscriptionWidget:sellingPlanChanged',
            { detail: card.dataset.acwPlan }
          ));
        });
      });
    }

    /* ── Einmalig-Optionen ───────────────────────────────── */
    if (onetimePanel) {
      var otCards = onetimePanel.querySelectorAll('[data-acw-onetime]');
      otCards.forEach(function (card) {
        card.addEventListener('click', function () {
          otCards.forEach(function (c) { c.classList.remove('acw__plan-card--active'); });
          card.classList.add('acw__plan-card--active');
          desiredPlanId = null;
          if (planInput) planInput.value = '';
          applyOnetimeCard(card);
          syncAppstle(null);
        });
      });
    }

    function setVariant(vid) {
      if (variantInput && vid) variantInput.value = vid;
    }

    function applyOnetimeCard(card) {
      if (!card) return;
      var vid = card.dataset.acwVariant;
      if (vid) setVariant(vid);
    }

    /* ── Vergleichspreise (Durchstreichpreis) ────────────────
       Einmalkauf: Vergleichspreis der Variante (Shopify-Feld "Vergleichspreis").
       Abo: Preis ohne Abo-Rabatt (selling_plan_allocation.compare_at_price) –
       im Modus 'uvp' stattdessen der Vergleichspreis, sofern er höher ist.
       Ohne Ersparnis wird nichts angezeigt (Element bleibt leer + versteckt). */
    function oneTimeCompare(variant) {
      var compare = variant.compareAtPrice || 0;
      return compare > variant.price ? compare : 0;
    }

    function subCompare(variant, alloc, planPrice) {
      var base = (alloc && alloc.compareAtPrice) ? alloc.compareAtPrice : variant.price;
      if (compareMode === 'uvp' && (variant.compareAtPrice || 0) > base) {
        base = variant.compareAtPrice;
      }
      return base > planPrice ? base : 0;
    }

    function setCompare(el, cents, format) {
      setCompareText(el, cents ? formatMoney(cents, format) : '');
    }

    function setCompareText(el, text) {
      if (!el) return;
      var value = text ? decodeEntities(text) : '';
      el.textContent = value;
      el.classList.toggle('acw__compare-price--hidden', !value);
    }

    function updateSavingsBadge(discount) {
      if (!savingsEl || !savingsTemplate) return;
      var text = decodeEntities(savingsTemplate);
      var value = discount || '0';
      savingsEl.textContent = text.indexOf('{discount}') !== -1
        ? text.replace('{discount}', value)
        : text.replace(/\d+(?:[.,]\d+)?\s*%/, value + '%');
    }

    /* Appstle DOM-Struktur (Stand 08/2026, per Live-Inspektion geprüft):
       - Radio in .appstle_one_time_details_wrapper   → One-Time Purchase (default checked)
       - Radio in .appstle_subscription_radio_wrapper → Subscribe & Save
       - select.appstle_select (kein name-Attribut!)  → Frequenz-Auswahl (value = Plan-ID)

       WICHTIG: BEIDE Radios haben inzwischen value="" — Appstle leitet den Plan aus
       "welches Radio ist checked" + dem Select ab. Die frühere Auswahl über
       input[name="selling_plan"]:not([value=""]) trifft deshalb nichts mehr, das
       Abo-Radio wurde nie aktiviert und Appstle hat jeden Add-to-Cart auf
       Einmalkauf zurückgesetzt. */
    function syncAppstle(planId) {
      var widget = document.querySelector('.appstle_sub_widget');
      if (!widget) return;

      var radios     = widget.querySelectorAll('input[name="selling_plan"]');
      var subRadio   = widget.querySelector('.appstle_subscription_radio_wrapper input[name="selling_plan"]')
                    || widget.querySelector('input[name="selling_plan"]:not([value=""])')
                    || radios[1];
      var oneTimeRadio = widget.querySelector('.appstle_one_time_details_wrapper input[name="selling_plan"]')
                    || radios[0];

      if (planId) {
        check(subRadio);

        /* Frequenz-Dropdown auf den gewählten Plan setzen */
        var sel = widget.querySelector('select.appstle_select');
        if (sel && String(sel.value) !== String(planId)) {
          sel.value = String(planId);
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        check(oneTimeRadio);
      }

      function check(radio) {
        if (!radio || radio.checked) return;
        radio.checked = true;
        /* click() zusätzlich, damit Appstles eigene (jQuery-)Handler feuern */
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        radio.click();
      }
    }
  }

  /* Wartet, bis das Appstle-Widget vollständig gerendert ist (App lädt asynchron) */
  function whenAppstleReady(cb) {
    var tries = 0;
    (function poll() {
      var w = document.querySelector('.appstle_sub_widget');
      if (w && w.querySelectorAll('input[name="selling_plan"]').length >= 2) { cb(); return; }
      if (++tries > 120) return; /* nach ~60 s aufgeben */
      setTimeout(poll, 500);
    })();
  }

  /* Re-Sync, wenn Appstle sein Widget neu rendert (Varianten-Wechsel, Re-Init) */
  function observeAppstle(cb) {
    var timer = null;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t && t.closest && (t.closest('.appstle_sub_widget') || (t.querySelector && t.querySelector('.appstle_sub_widget')))) {
          clearTimeout(timer);
          timer = setTimeout(cb, 200);
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ── Varianten-Change-Event ──────────────────────────────
     Hört auf das Shopify-Standard-Muster:
     – input[name="id"] oder select[name="id"] im Form
     – custom Events von Dawn / anderen Themes
     – URL-Änderung als Fallback                           */
  function listenVariantChange(form, callback) {
    if (!form) return;

    var varInput = form.querySelector('select[name="id"], input[name="id"]');
    if (varInput) {
      varInput.addEventListener('change', function () {
        callback(varInput.value);
      });
    }

    document.addEventListener('variant:changed', function (e) {
      var vid = e.detail && (e.detail.variant && e.detail.variant.id || e.detail.id);
      if (vid) callback(String(vid));
    });

    var lastVariant = getVariantFromUrl();
    window.addEventListener('popstate', checkUrl);
    patchPushState(checkUrl);

    function checkUrl() {
      var vid = getVariantFromUrl();
      if (vid && vid !== lastVariant) {
        lastVariant = vid;
        callback(vid);
      }
    }
  }

  /* history.pushState einmalig patchen — Guard verhindert
     Konflikte wenn mehrere Scripts dasselbe versuchen */
  function patchPushState(fn) {
    if (!window.__acwPushListeners) {
      window.__acwPushListeners = [];
      var orig = history.pushState.bind(history);
      history.pushState = function () {
        orig.apply(history, arguments);
        window.__acwPushListeners.forEach(function (cb) { cb(); });
      };
    }
    window.__acwPushListeners.push(fn);
  }

  function getVariantFromUrl() {
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function findProductForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    if (forms.length === 1) return forms[0];
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('input[name="id"], select[name="id"]')) return forms[i];
    }
    return forms[0] || null;
  }

  /* ── Hilfsfunktionen ─────────────────────────────────── */
  function parseData(sectionId) {
    var el = document.getElementById('acw-data-' + sectionId);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function buildVariantMap(data) {
    var map = {};
    if (!data || !data.variants) return map;
    data.variants.forEach(function (v) { map[String(v.id)] = v; });
    return map;
  }

  function findAlloc(allocations, planId) {
    if (!allocations) return null;
    for (var i = 0; i < allocations.length; i++) {
      if (allocations[i].sellingPlanId === planId) return allocations[i];
    }
    return null;
  }

  /* Eigenes Hidden-Input für selling_plan.
     Bewusst NICHT über input[name="selling_plan"] gesucht: je nach Ladereihenfolge
     träfe das die Radios des Appstle-Widgets — dann hätten wir in dessen Radio
     geschrieben statt in ein eigenes Feld (zweite Ursache der Sprunghaftigkeit). */
  function getOrCreatePlanInput(form, initialValue) {
    if (!form) return null;
    var el = form.querySelector('input[data-acw-selling-plan]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'selling_plan';
      el.setAttribute('data-acw-selling-plan', '');
      el.value = initialValue;
      form.appendChild(el);
    }
    return el;
  }

  /* Findet auch select-Elemente (z.B. Variant-Picker im Theme); Appstle-Widget ausgenommen */
  function getOrCreateInputOrSelect(form, name, initialValue) {
    if (!form) return null;
    var candidates = form.querySelectorAll('input[name="' + name + '"], select[name="' + name + '"]');
    var el = null;
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i].closest('.appstle_sub_widget')) { el = candidates[i]; break; }
    }
    if (!el) {
      el = document.createElement('input');
      el.type  = 'hidden';
      el.name  = name;
      el.value = initialValue;
      form.appendChild(el);
    }
    return el;
  }

  function formatMoney(cents, format) {
    var result;
    if (window.Shopify && window.Shopify.formatMoney) {
      result = window.Shopify.formatMoney(cents, format);
    } else {
      result = (cents / 100).toFixed(2).replace('.', ',') + '€';
    }
    result = result.replace(/^\s*€\s*(.+?)\s*$/, '$1€');
    result = result.replace(/\s*€$/, '€');
    return result;
  }

  function decodeEntities(str) {
    var el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }

  /* ── Init ────────────────────────────────────────────── */
  function init() {
    document.querySelectorAll('[data-acw]').forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
